<template>
  <Card theme="flat" class="residentials-update__content">
    <template #default>
      <div class="residentials-update__content-inputs">
        <CustomFields :value="valueComp" @input="e => $emit('updateValue', e)" :schema="schema" :data="valueComp">
          <!-- render slots -->
          <template v-for="field in fields.slots" v-slot:[field.slotKey]>
            <FieldRenderer
              :item="{ ...field, props: { ...field.props, ...getProps(field) } }"
              :value="valueComp"
              @input="e => $emit('updateValue', { ...e, slot: true })"
            />
          </template>
        </CustomFields>
      </div>
    </template>
    <template #footer>
      <slot name="navigation"></slot>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { getStatusSuffix } from '@/views/Residential/Mutate/Component'
import Components from '@/components/Residential/Fields'
import Card from '@/components/Card'
import { AlertComponent as Alert } from 'vue-elder-alert'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'

const meta = {
  order: 2,
  id: 'content',
}

export { meta }
export default {
  props: {
    value: Function,
    labels: Object,
    validator: Object,
    isActive: Boolean,
    residentials: Array,
    selected: Object,
    schemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
    disabledFields: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isActive: {
      handler: 'prepare',
      immediate: true,
    },
  },
  data() {
    return {
      currentField: {},
      schema: [],
    }
  },
  computed: {
    ...mapState('Project', {
      project: state => state.item,
      units(state) {
        return this.$path('item.metadata.limits.units', state)
      },
      addons(state) {
        return this.$path('item.metadata.addons', state) || []
      },
    }),
    valueComp() {
      return this.value()
    },

    saleTypes() {
      return Array.from(new Set(this.residentials.map(r => r.sale.type)))
    },
    propertyTypes() {
      return Array.from(
        new Set(this.residentials.map(r => (r.properties.find(i => i.key === 'propertyType') || {}).value)),
      )
    },
  },
  methods: {
    getProps(field) {
      if (!field.key) return {}
      const props = {
        Default: { 'data-field': field },
        SaleType: { 'sale-type': this.saleTypes.length > 1 ? undefined : this.saleTypes[0] },
        PropertyTypes: { 'property-types': this.propertyTypes },
      }
      if (field.key === 'properties')
        return { ...props.Default, ...props.PropertyTypes, disabledFields: this.disabledFields }
      if (field.key === 'sale') return { ...props.Default, ...props.SaleType }
      if (field.key === 'status') {
        return {
          ...props.Default,
          ...props.SaleType,
          suffix: status => getStatusSuffix(status, this.addons),
          isDisabled: status => {
            if (this.addons.includes('project:bid') && status === 'sold') return true
            return false
          },
        }
      }

      return props.Default
    },

    findField(value, field) {
      if (!(value.component instanceof Array)) return

      const match = value.component.find(c => {
        if (c.label === field) {
          this.currentField = c
          return c
        }
        return
      })
      if (!match) return

      return {
        ...value,
        options: {
          ...value.options,
          layout: match ? `${match.key}` : '',
          condition: null,
          collapsible: false,
        },
        component: [
          { ...match, label: (match.label || '').split('/').pop(), options: { ...match.options, collapsible: false } },
        ],
      }
    },

    prepare() {
      this.schema = this.schemas
        .map(i => this.findField(i, this.selected.value))
        .filter(Boolean)
        .flat(Infinity)
    },
  },
  components: {
    ...Components,
    Card,
    Alert,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.residentials-update__content {
  &-inputs {
    max-height: 80vh;
    overflow-y: scroll;

    @include scrollShadow();

    display: grid;
    grid-gap: $form-gap;

    .elder-image__droparea {
      height: 200px;
      flex-grow: 0;
    }
  }
}
</style>
